import { request } from "../fetch";
import { uploadFoto } from "../fetch";
import {
  resolverFotoParaCriar,
  resolverFotoParaAtualizar,
} from "@/hooks/useUploadFoto";

class ClinicaService {
  // ── Clínicas ──────────────────────────────────────────────────────────────

  static async getAllClinicasComFiliais() {
    return request("api/adm/clinicas/com-filiais");
  }

  static async create(data) {
    const payload = { ...data, fotoId: null };
    payload.foto = await resolverFotoParaCriar(payload.foto);
    return request("api/adm/clinicas", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  static async update(id, data) {
    const payload = { ...data };
    payload.foto = await resolverFotoParaAtualizar(payload.fotoId, payload.foto);
    return request(`api/adm/clinicas/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  static async removeClinica(data) {
    if (data?.foto) {
      await uploadFoto.deletar(data?.foto?._id);
    }
    return request(`api/adm/clinicas/${data._id}`, { method: "DELETE" });
  }

  // ── Filiais ───────────────────────────────────────────────────────────────

  static async createFilial(clinicaId, data) {
    const payload = { ...data, fotoId: null };
    payload.foto = await resolverFotoParaCriar(payload.foto);
    return request(`api/adm/clinicas/${clinicaId}/filial`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  static async updateFilial(id, data) {
    const payload = { ...data };
    payload.foto = await resolverFotoParaAtualizar(payload.fotoId, payload.foto);
    return request(`api/adm/clinicas/filial/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  static async removeFilial(data) {
    if (data?.foto) {
      await uploadFoto.deletar(data?.foto?._id);
    }
    return request(`api/adm/clinicas/filial/${data._id}`, { method: "DELETE" });
  }

  // ── Config NPS (pesquisa de satisfação) ─────────────────────────────────────

  static async getConfigNps(id) {
    return request(`api/adm/clinicas/${id}/config-nps`);
  }

  static async updateConfigNps(id, nps) {
    return request(`api/adm/clinicas/${id}/config-nps`, {
      method: "PUT",
      body: JSON.stringify({ nps }),
    });
  }
}

export { ClinicaService };
